import script from "./ActiveGiftCode.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveGiftCode.vue?vue&type=script&setup=true&lang=js"

import "./ActiveGiftCode.vue?vue&type=style&index=0&id=a4359734&lang=scss"

const __exports__ = script;

export default __exports__